import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import ImageShape from "%/dynamic-components/render-engine/options/image-options/image-shape";
import ObjectPosition from "%/dynamic-components/render-engine/options/image-options/object-position";
import SingleImage from "%/dynamic-components/render-engine/options/image-options/single-image";
import ImageAltText from "%/dynamic-components/render-engine/options/image-options/image-alt-text";
import ImageFillBackground from "%/dynamic-components/render-engine/options/image-options/image-fill-background";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import Crop from "%/dynamic-components/render-engine/options/image-options/crop";
import Brightness from "%/dynamic-components/render-engine/options/image-options/brightness";
import Contrast from "%/dynamic-components/render-engine/options/image-options/contrast";
import Grayscale from "%/dynamic-components/render-engine/options/image-options/grayscale";
import HueRotate from "%/dynamic-components/render-engine/options/image-options/hue-rotate";
import Invert from "%/dynamic-components/render-engine/options/image-options/invert";
import Saturate from "%/dynamic-components/render-engine/options/image-options/saturate";
import Sepia from "%/dynamic-components/render-engine/options/image-options/sepia";
import Blur from "%/dynamic-components/render-engine/options/layout-options/blur";
import ImageOpacity from "%/dynamic-components/render-engine/options/image-options/opacity";
import BlendMode from "%/dynamic-components/render-engine/options/image-options/blend-mode";
import Rendering from "%/dynamic-components/render-engine/options/image-options/rendering";
import ClipPath from "%/dynamic-components/render-engine/options/image-options/clip-path";

export default class ImageOptions extends BaseOptionsBundle {

  optionTitle = "Image";
  static optionClassName = "i-dynamic-image";
  inspectorToolGroup = "image";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.IMAGE_TOOLSET,
  };

  constructor(values = {}) {
    super(values, [
      SingleImage,
      ImageAltText,
      ImageShape,
      ObjectPosition,
      Crop,
      ImageFillBackground,

      // Effect Options
      Blur,
      Brightness,
      Contrast,
      Grayscale,
      HueRotate,
      Invert,
      ImageOpacity,
      Saturate,
      Sepia,
      BlendMode,
      Rendering,
      ClipPath,
    ]);
  }
}
